import CompletedStoreAuditsChart from './CompletedStoreAuditsChart';
export default CompletedStoreAuditsChart;
